
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="scrollToColKey 列滚动方法" fileName="scroll-to-col-key.md" />
        <p>当存在固定列时，可以通过此方法将指定的列显示在可视区域</p>
<demo-block>
        <div><p>1、滚动到指定 column 位置</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;div style=&quot;margin-bottom:20px;line-height:3.0;&quot;&gt;
            &lt;button class=&quot;button-demo&quot; @click=&quot;scrollToColKey('col4')&quot;&gt;滚动到col4列&lt;/button&gt;
            &lt;button class=&quot;button-demo&quot; @click=&quot;scrollToColKey('col5')&quot;&gt;滚动到col5列&lt;/button&gt;
            &lt;button class=&quot;button-demo&quot; @click=&quot;scrollToColKey('col6')&quot;&gt;滚动到col6列&lt;/button&gt;
        &lt;/div&gt;
        &lt;ve-table
            ref=&quot;tableRef&quot;
            style=&quot;width:1000px&quot;
            :scroll-width=&quot;1600&quot;
            :max-height=&quot;350&quot;
            border-y
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            rowKeyFieldName=&quot;rowKey&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columns: [
                    {
                        field: &quot;col1&quot;,
                        key: &quot;a&quot;,
                        title: &quot;col1&quot;,
                        width: 50,
                        fixed: &quot;left&quot;,
                    },
                    {
                        title: &quot;col2-col3&quot;,
                        fixed: &quot;left&quot;,
                        children: [
                            {
                                field: &quot;col2&quot;,
                                key: &quot;b&quot;,
                                title: &quot;col2&quot;,
                                width: 50,
                            },
                            {
                                field: &quot;col3&quot;,
                                key: &quot;c&quot;,
                                title: &quot;col3&quot;,
                                width: 50,
                            },
                        ],
                    },
                    {
                        title: &quot;col4-col5-col6&quot;,
                        children: [
                            {
                                title: &quot;col4-col5&quot;,
                                children: [
                                    {
                                        field: &quot;col4&quot;,
                                        key: &quot;col4&quot;,
                                        title: &quot;col4&quot;,
                                        width: 130,
                                    },
                                    {
                                        field: &quot;col5&quot;,
                                        key: &quot;col5&quot;,
                                        title: &quot;col5&quot;,
                                        width: 140,
                                    },
                                ],
                            },
                            {
                                title: &quot;col6&quot;,
                                field: &quot;col6&quot;,
                                key: &quot;col6&quot;,
                                width: 140,
                            },
                        ],
                    },
                    {
                        title: &quot;col7&quot;,
                        fixed: &quot;right&quot;,
                        children: [
                            {
                                title: &quot;col7-1&quot;,
                                field: &quot;col7&quot;,
                                key: &quot;g&quot;,
                                width: 50,
                            },
                        ],
                    },
                    {
                        field: &quot;col8&quot;,
                        key: &quot;h&quot;,
                        title: &quot;col8&quot;,
                        width: 50,
                        fixed: &quot;right&quot;,
                    },
                ],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 80; i++) {
                    data.push({
                        rowKey: i,
                        col1: i,
                        col2: i,
                        col3: i,
                        col4: i,
                        col5: i,
                        col6: i,
                        col7: i,
                        col8: i,
                    });
                }
                this.tableData = data;
            },
            // scroll y
            scrollToColKey(colKey) {
                this.$refs[&quot;tableRef&quot;].scrollToColKey({ colKey });
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('div',{staticStyle:{"margin-bottom":"20px","line-height":"3.0"}},[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.scrollToColKey('col4')}}},[_vm._v("滚动到col4列")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.scrollToColKey('col5')}}},[_vm._v("滚动到col5列")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.scrollToColKey('col6')}}},[_vm._v("滚动到col6列")])]),_vm._v(" "),_c('ve-table',{ref:"tableRef",staticStyle:{"width":"1000px"},attrs:{"scroll-width":1600,"max-height":350,"border-y":"","columns":_vm.columns,"table-data":_vm.tableData,"rowKeyFieldName":"rowKey"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columns: [
                    {
                        field: "col1",
                        key: "a",
                        title: "col1",
                        width: 50,
                        fixed: "left",
                    },
                    {
                        title: "col2-col3",
                        fixed: "left",
                        children: [
                            {
                                field: "col2",
                                key: "b",
                                title: "col2",
                                width: 50,
                            },
                            {
                                field: "col3",
                                key: "c",
                                title: "col3",
                                width: 50,
                            },
                        ],
                    },
                    {
                        title: "col4-col5-col6",
                        children: [
                            {
                                title: "col4-col5",
                                children: [
                                    {
                                        field: "col4",
                                        key: "col4",
                                        title: "col4",
                                        width: 130,
                                    },
                                    {
                                        field: "col5",
                                        key: "col5",
                                        title: "col5",
                                        width: 140,
                                    },
                                ],
                            },
                            {
                                title: "col6",
                                field: "col6",
                                key: "col6",
                                width: 140,
                            },
                        ],
                    },
                    {
                        title: "col7",
                        fixed: "right",
                        children: [
                            {
                                title: "col7-1",
                                field: "col7",
                                key: "g",
                                width: 50,
                            },
                        ],
                    },
                    {
                        field: "col8",
                        key: "h",
                        title: "col8",
                        width: 50,
                        fixed: "right",
                    },
                ],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 80; i++) {
                    data.push({
                        rowKey: i,
                        col1: i,
                        col2: i,
                        col3: i,
                        col4: i,
                        col5: i,
                        col6: i,
                        col7: i,
                        col8: i,
                    });
                }
                this.tableData = data;
            },
            // scroll y
            scrollToColKey(colKey) {
                this.$refs["tableRef"].scrollToColKey({ colKey });
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  